"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("pixi-compressed-textures");
var client_1 = __importDefault(require("./models/client"));
var guide_1 = __importStar(require("./models/guide"));
var backdrop_container_1 = __importDefault(require("./views/backdrop-container"));
var dragon_container_1 = __importDefault(require("./views/dragon-container"));
var state_machine_1 = __importDefault(require("./states/state-machine"));
var loading_state_1 = __importDefault(require("./states/loading-state"));
var hatch_state_1 = __importDefault(require("./states/hatch-state"));
var evolve_state_1 = __importDefault(require("./states/evolve-state"));
var gift_state_1 = __importDefault(require("./states/gift-state"));
var home_state_1 = __importDefault(require("./states/home-state"));
var park_state_1 = __importDefault(require("./states/park-state"));
var feed_state_1 = __importDefault(require("./states/feed-state"));
var clean_state_1 = __importDefault(require("./states/clean-state"));
var customize_state_1 = __importDefault(require("./states/customize-state"));
var breathe_state_1 = __importDefault(require("./states/breathe-state"));
var memorize_state_1 = __importDefault(require("./states/memorize-state"));
var guide_state_1 = __importDefault(require("./states/guide-state"));
var name_state_1 = __importDefault(require("./states/name-state"));
var profile_state_1 = __importDefault(require("./states/profile-state"));
var send_state_1 = __importDefault(require("./states/send-state"));
var inbox_state_1 = __importDefault(require("./states/inbox-state"));
var scoring_state_1 = __importDefault(require("./states/scoring-state"));
var promo_state_1 = __importDefault(require("./states/promo-state"));
var game_area_1 = require("./utilities/game-area");
var calculator_1 = __importDefault(require("./models/calculator"));
var gift_1 = __importDefault(require("./models/gift"));
var evolution_1 = __importDefault(require("./models/evolution"));
var acknowledgement_1 = __importDefault(require("./models/acknowledgement"));
var i18next_1 = __importDefault(require("i18next"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var en_json_1 = __importDefault(require("../assets/locales/en.json"));
var de_json_1 = __importDefault(require("../assets/locales/de.json"));
var Main = /** @class */ (function () {
    function Main() {
    }
    Object.defineProperty(Main.prototype, "client", {
        get: function () {
            if (!this._client) {
                this._client = new client_1.default();
            }
            return this._client;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Main.prototype, "guide", {
        get: function () {
            if (!this._guide) {
                this._guide = new guide_1.default();
            }
            return this._guide;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Main.prototype, "app", {
        get: function () {
            var _this = this;
            if (!this._app) {
                var resolution = Math.min(devicePixelRatio, 2);
                PIXI.settings.FILTER_RESOLUTION = resolution;
                PIXI.settings.CAN_UPLOAD_SAME_BUFFER = false;
                PIXI.GRAPHICS_CURVES.maxLength = 5;
                this._app = new PIXI.Application({
                    autoDensity: true,
                    resolution: resolution
                });
                this._app.renderer.plugins.interaction.moveWhenInside = true;
                this._app.ticker.add(function () { return _this.update(_this.app.ticker.elapsedMS); }, this);
                document.body.appendChild(this._app.view);
                var mask = new PIXI.Graphics();
                mask.beginFill();
                mask.drawRect(0, 0, game_area_1.GAME_WIDTH, game_area_1.GAME_HEIGHT);
                mask.endFill();
                this._app.stage.mask = mask;
                this._app.stage.addChild(mask);
                window.addEventListener("resize", this.resize.bind(this));
                this.resize();
                var atlasOptions = { metadata: { choice: ["@1x.json", "@2x.json"] } };
                var spineOptions = { metadata: { spineMetadata: { choice: ["@1x.atlas", "@2x.atlas"] } } };
                this._app.loader
                    .add("ui", "assets/ui/ui.json", atlasOptions)
                    .add("backdrop", "assets/backdrop/backdrop.json", spineOptions)
                    .add("dragon", "assets/dragon/dragon.json", spineOptions)
                    .add("gift", "assets/gift/gift.json", spineOptions)
                    .add("park", "assets/park/park.json", spineOptions)
                    .add("memorize", "assets/memorize/memorize.json", spineOptions)
                    .add("breathe", "assets/breathe/breathe.json", spineOptions)
                    .add("profile", "assets/profile/profile.json", spineOptions)
                    .pre(PIXI.compressedTextures.extensionChooser(PIXI.compressedTextures.detectExtensions(this._app.renderer)));
            }
            return this._app;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Main.prototype, "stateMachine", {
        get: function () {
            if (!this._stateMachine) {
                this._stateMachine = new state_machine_1.default([
                    new loading_state_1.default(this.app, this.client),
                    new hatch_state_1.default(this.app, this.client, this.guide, this.backdropContainer, this.dragonContainer),
                    new evolve_state_1.default(this.app, this.client, this.guide, this.backdropContainer, this.dragonContainer),
                    new gift_state_1.default(this.app, this.client, this.backdropContainer, this.dragonContainer),
                    new home_state_1.default(this.app, this.client, this.guide, this.backdropContainer, this.dragonContainer),
                    new park_state_1.default(this.app, this.client, this.dragonContainer),
                    new feed_state_1.default(this.app, this.client, this.backdropContainer, this.dragonContainer),
                    new clean_state_1.default(this.app, this.client, this.backdropContainer, this.dragonContainer),
                    new customize_state_1.default(this.app, this.client, this.backdropContainer, this.dragonContainer),
                    new breathe_state_1.default(this.app, this.client, this.dragonContainer),
                    new memorize_state_1.default(this.app, this.client, this.dragonContainer),
                    new guide_state_1.default(this.app, this.client, this.guide, this.backdropContainer, this.dragonContainer),
                    new name_state_1.default(this.app, this.client, this.backdropContainer, this.dragonContainer),
                    new profile_state_1.default(this.app, this.client),
                    new send_state_1.default(this.app, this.client),
                    new inbox_state_1.default(this.app, this.client),
                    new scoring_state_1.default(this.app, this.client),
                    new promo_state_1.default(this.app, this.client)
                ]);
            }
            return this._stateMachine;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Main.prototype, "backdropContainer", {
        get: function () {
            if (!this._backdropContainer) {
                this._backdropContainer = new backdrop_container_1.default(this._app.loader.resources);
                this._backdropContainer.scale.set(0.5);
                this._backdropContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._backdropContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Main.prototype, "dragonContainer", {
        get: function () {
            if (!this._dragonContainer) {
                this._dragonContainer = new dragon_container_1.default(this._app.loader.resources);
            }
            return this._dragonContainer;
        },
        enumerable: false,
        configurable: true
    });
    Main.prototype.update = function (deltaTime) {
        this.checkState();
        this._stateMachine.update(deltaTime);
        if (this.client.dragon) {
            var appearance = this.client.dragon.appearance;
            this._backdropContainer.configureAppearance(appearance.backdrop);
            var now = new Date();
            var quitDay = calculator_1.default.day(this.client.dragon.quit.start, now);
            var stage = this.client.dragon.status.stage;
            var hatched = calculator_1.default.hatched(stage);
            var lastSmoked = this.client.dragon.quit.lastSmoked;
            var lastVisit = this.client.dragon.status.saved;
            var recentlyLapsed = calculator_1.default.recentlyLapsed(now, lastSmoked);
            var meterDecay = calculator_1.default.meterDecay(stage, lastVisit, now);
            var dirty = calculator_1.default.dirty(this.client.dragon.meters.hygiene - meterDecay);
            this._dragonContainer.setHatched(hatched);
            this._dragonContainer.configureAppearance(quitDay, appearance.body, appearance.eyes, appearance.head, appearance.scales, appearance.tail, appearance.wings, appearance.hat, appearance.collar, appearance.band, dirty, recentlyLapsed);
        }
    };
    Main.prototype.checkState = function () {
        if (!this.client.dragon) {
            this.stateMachine.enter(loading_state_1.default);
            return;
        }
        if (this.stateMachine.currentState.constructor == loading_state_1.default) {
            this.stateMachine.enter(home_state_1.default);
        }
        this.checkQuit();
        this.checkPromo() || this.checkPrequit() || this.checkLapse() || this.checkLevel() || this.checkHatch() || this.checkEvolution() || this.checkAchievements();
    };
    Main.prototype.checkQuit = function () {
        var oldQuit = this.client.dragon.quit;
        var newQuit = this.client.quit;
        if (newQuit && JSON.stringify(oldQuit) != JSON.stringify(newQuit)) {
            this.client.dragon.quit = newQuit;
            this.client.synchronize();
            this.client.sendEvent("quit_changed", {
                old: oldQuit,
                new: newQuit
            });
        }
    };
    Main.prototype.checkPromo = function () {
        if (this.stateMachine.currentState.constructor == promo_state_1.default) {
            return true;
        }
        if (this.client.dragon.status.showPromo) {
            this.stateMachine.push(promo_state_1.default);
            return true;
        }
        return false;
    };
    Main.prototype.checkPrequit = function () {
        if (this.stateMachine.currentState.constructor == guide_state_1.default) {
            return true;
        }
        if (this.client.dragon.status.showPrequit) {
            var now = new Date();
            var oldStage = this.client.dragon.status.stage;
            var newStage = calculator_1.default.stage(this.client.dragon.quit.start, now);
            if (oldStage == 0 && newStage == 0) {
                this._client.dragon.status.showPrequit = false;
                this._client.synchronize();
                var pages = [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_prequit_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_prequit_2"))
                    ], [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_prequit_3")),
                        this._client.park ? new guide_1.GuideMessage(i18next_1.default.t("guide_prequit_4")) : null
                    ]
                ];
                this.guide.setPages(pages);
                this.stateMachine.push(guide_state_1.default);
            }
        }
        return false;
    };
    Main.prototype.checkLapse = function () {
        var lastVisit = this.client.dragon.status.saved;
        var lastSmoked = this.client.dragon.quit.lastSmoked;
        var now = new Date();
        var meterReset = calculator_1.default.meterReset(lastVisit, now, lastSmoked);
        if (meterReset) {
            var meters = this.client.dragon.meters;
            meters.calmness = Math.min(meters.calmness, meterReset);
            meters.nutrition = Math.min(meters.nutrition, meterReset);
            meters.hygiene = Math.min(meters.hygiene, meterReset);
            meters.energy = Math.min(meters.energy, meterReset);
            this.client.dragon.status.saved = now;
            this.client.synchronize();
            this.client.sendEvent("lapse_penalized", {
                dragon: this.client.dragon
            });
            var pages = [
                [
                    new guide_1.GuideMessage(i18next_1.default.t("guide_lapse_1")),
                    new guide_1.GuideMessage(i18next_1.default.t("guide_lapse_2"))
                ], [
                    new guide_1.GuideMessage(i18next_1.default.t("guide_lapse_3"))
                ]
            ];
            this.guide.setPages(pages);
            this.stateMachine.push(guide_state_1.default);
            return true;
        }
        return false;
    };
    Main.prototype.checkLevel = function () {
        if (this.stateMachine.currentState.constructor == gift_state_1.default) {
            return true;
        }
        var oldLevel = this.client.dragon.status.level;
        var newLevel = calculator_1.default.level(this.client.dragon.status.xp);
        var gift = gift_1.default.Compare(oldLevel, newLevel, this.client.dragon.unlocks);
        if (gift) {
            this.stateMachine.push(gift_state_1.default, function (state) {
                state.gift = gift;
            });
            return true;
        }
        return false;
    };
    Main.prototype.checkHatch = function () {
        if (this.stateMachine.currentState.constructor == hatch_state_1.default ||
            this.stateMachine.currentState.constructor == guide_state_1.default) {
            return true;
        }
        var now = new Date();
        var oldStage = this.client.dragon.status.stage;
        var newStage = calculator_1.default.stage(this.client.dragon.quit.start, now);
        if (oldStage == 0 && newStage > oldStage) {
            this.stateMachine.push(hatch_state_1.default);
            return true;
        }
        return false;
    };
    Main.prototype.checkEvolution = function () {
        if (this.stateMachine.currentState.constructor == evolve_state_1.default ||
            this.stateMachine.currentState.constructor == guide_state_1.default) {
            return true;
        }
        var now = new Date();
        var oldStage = this.client.dragon.status.stage;
        var newStage = calculator_1.default.stage(this.client.dragon.quit.start, now);
        var evolution = evolution_1.default.Compare(oldStage, newStage, this.client.dragon.unlocks);
        if (evolution) {
            this.stateMachine.push(evolve_state_1.default, function (state) {
                state.evolution = evolution;
            });
            return true;
        }
        return false;
    };
    Main.prototype.checkAchievements = function () {
        var e_1, _a;
        var _this = this;
        if (this.stateMachine.currentState.constructor == guide_state_1.default) {
            return true;
        }
        var oldAchievements = this.client.dragon.achievements;
        var newAchievements = this.client.achievements;
        if (!oldAchievements || !newAchievements) {
            return false;
        }
        var acknowledgements = acknowledgement_1.default.Compare(oldAchievements, newAchievements);
        if (acknowledgements) {
            var checkinStreak = newAchievements.checkinStreak;
            var showStreakBonus = checkinStreak > 1;
            var xpMultiplier = calculator_1.default.xpMultiplier(checkinStreak);
            var firstMessage;
            if (showStreakBonus) {
                firstMessage = new guide_1.GuideMessage(i18next_1.default.t("guide_acknowledgement_1_streak")
                    .replace("[day]", String(checkinStreak.toFixed()))
                    .replace("[percentage]", String(((xpMultiplier - 1) * 100).toFixed())));
            }
            else {
                firstMessage = new guide_1.GuideMessage(i18next_1.default.t("guide_acknowledgement_1"));
            }
            var pages = [];
            pages.push([
                firstMessage,
                new guide_1.GuideMessage(i18next_1.default.t("guide_acknowledgement_2"))
            ]);
            var totalBaseXP = 0;
            try {
                for (var acknowledgements_1 = __values(acknowledgements), acknowledgements_1_1 = acknowledgements_1.next(); !acknowledgements_1_1.done; acknowledgements_1_1 = acknowledgements_1.next()) {
                    var acknowledgement = acknowledgements_1_1.value;
                    var messages = [
                        new guide_1.GuideMessage(acknowledgement.name + ": " + acknowledgement.quantity.toFixed()),
                        new guide_1.GuideMessage("+" + acknowledgement.xp.toFixed() + " " + i18next_1.default.t("xp"), guide_1.GUIDE_MESSAGE_TYPE.IMPORTANT)
                    ];
                    if (showStreakBonus) {
                        var bonusXP = acknowledgement.xp * (xpMultiplier - 1);
                        messages.push(new guide_1.GuideMessage("+" + bonusXP.toFixed() + " " + i18next_1.default.t("xp") + " " + i18next_1.default.t("xp_streak_bonus"), guide_1.GUIDE_MESSAGE_TYPE.BONUS));
                    }
                    pages.push(messages);
                    totalBaseXP += acknowledgement.xp;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (acknowledgements_1_1 && !acknowledgements_1_1.done && (_a = acknowledgements_1.return)) _a.call(acknowledgements_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.guide.setPages(pages, function () {
                _this.client.dragon.achievements = _this.client.achievements;
                _this.client.award(totalBaseXP);
                _this.client.synchronize();
                _this.client.sendEvent("achievements_awarded", {
                    old: oldAchievements,
                    new: newAchievements
                });
            });
            this.stateMachine.push(guide_state_1.default);
            return true;
        }
        return false;
    };
    Main.prototype.resize = function () {
        var screenWidth = window.innerWidth;
        var screenHeight = window.innerHeight;
        this.app.renderer.resize(screenWidth, screenHeight);
        var gameScale = Math.min(screenWidth / game_area_1.GAME_SAFE_AREA.width, screenHeight / game_area_1.GAME_SAFE_AREA.height);
        this.app.stage.scale.set(gameScale);
        this.app.stage.position.set((screenWidth - game_area_1.GAME_WIDTH * gameScale) * 0.5, (screenHeight - game_area_1.GAME_HEIGHT * gameScale) * 0.5);
    };
    return Main;
}());
i18next_1.default
    .use(i18next_browser_languagedetector_1.default)
    .init({
    fallbackLng: "en",
    resources: {
        en: { translation: en_json_1.default },
        de: { translation: de_json_1.default }
    },
    detection: {
        order: ["navigator"],
        caches: []
    }
});
var main = new Main();
main.app;
